//#region types
import { CurrencyEnums, FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { SupplierFormTypes } from "models/formTypes";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
import { FilterHelper, QueryStateHelper } from "utils/helpers";

function useSuppliersReportFilterDefinition() {
  const apiToReportFilterFormatter = async (
    filter: WintSuperkollAPIModel.IncomingInvoiceSupplierFilter
  ): Promise<SupplierFormTypes.Filter> => {
    const reportFilter: SupplierFormTypes.Filter = {
      search: filter.name,
      hasRules: filter.hasRules,
      hasUnpaidInvoices: filter.hasUnpaidInvoices,
    };

    FilterHelper.setDateRange(
      reportFilter,
      FormFieldConstants.Supplier.Filter.InvoiceDate,
      filter.invoiceDateFrom,
      filter.invoiceDateTo
    );

    FilterHelper.setNumberRange(
      reportFilter,
      FormFieldConstants.Supplier.Filter.NumberOfInvoices,
      filter.numberOfInvoicesFrom,
      filter.numberOfInvoicesTo
    );

    FilterHelper.setNumberRange(
      reportFilter,
      FormFieldConstants.Supplier.Filter.InvoicedAmount,
      filter.invoicedAmountFrom,
      filter.invoicedAmountTo
    );

    return reportFilter;
  };

  const filterFormFields: GenericFormSection<SupplierFormTypes.Filter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        invoiceDate: {
          label: TranslationKeys.Invoice.InvoiceDate,
          type: FormEnums.FormFieldType.DATERANGE,
        },
        hasRules: {
          label: TranslationKeys.Supplier.HasRules,
          type: FormEnums.FormFieldType.BOOLEANSELECTION,
        },
        hasUnpaidInvoices: {
          label: TranslationKeys.Supplier.HasUnpaidInvoices,
          type: FormEnums.FormFieldType.BOOLEANSELECTION,
        },
        numberOfInvoices: {
          label: TranslationKeys.Supplier.NumberOfInvoices,
          type: FormEnums.FormFieldType.NUMBERRANGE,
        },
        invoicedAmount: {
          label: TranslationKeys.Common.InvoicedAmount,
          type: FormEnums.FormFieldType.CURRENCYRANGE,
          extraProps: {
            currency: CurrencyEnums.CurrencyCode.SEK,
            allowNegative: true,
          },
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<SupplierFormTypes.Filter> = {
    search: QueryStateHelper.stringQueryEncoder(FormFieldConstants.Supplier.Filter.Search),
    invoiceDate: QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.Supplier.Filter.InvoiceDate),
    hasRules: QueryStateHelper.booleanQueryEncoder(FormFieldConstants.Supplier.Filter.HasRules),
    hasUnpaidInvoices: QueryStateHelper.booleanQueryEncoder(FormFieldConstants.Supplier.Filter.HasUnpaidInvoices),
    numberOfInvoices: QueryStateHelper.numberRangeQueryEncoder(FormFieldConstants.Supplier.Filter.NumberOfInvoices),
    invoicedAmount: QueryStateHelper.numberRangeQueryEncoder(FormFieldConstants.Supplier.Filter.InvoicedAmount),
  };

  return { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter };
}

export default useSuppliersReportFilterDefinition;
